<script lang="ts" setup>
const props = defineProps<{
  data: {
    id: number
    counter: string
    suffix?: string
    video: DirectusFile
    description?: string
  }
}>()

const video = ref<HTMLVideoElement>()
const item = ref<HTMLDivElement>()

const counter = computed(() => {
  return Number.parseInt(props.data.counter)
})

const isHovered = useElementHover(item)

const counterDisplay = ref(0)

watchEffect(() => {
  if (isHovered.value)
    video.value?.play()
  else
    video.value?.pause()
})

const { locale } = useI18n()

const config = useRuntimeConfig()
const _assetRoot = `${config.public.directus.url}/assets/`

const videoAssetRoot = `${config.public.directus.remote_file_storage}/`

const { $gsap } = useNuxtApp()

onMounted(() => {
  $gsap.to(counterDisplay, {
    value: counter.value,
    duration: 2,
    ease: 'power2.inOut',
    scrollTrigger: {
      trigger: item.value,
      start: 'top 80%',
    },
  })
})

const fancyDisplayNumber = computed(() => {
  return new Intl.NumberFormat(locale.value, { maximumFractionDigits: 0 }).format(
    Math.floor(counterDisplay.value),
  )
})
</script>

<template>
  <div ref="item" class="flex flex-col items-center justify-start border border-neutral-darkGray bg-neutral-black p-2rem">
    <div class="relative">
      <video ref="video" disablepictureinpicture muted playsinline loop class="aspect-video h-full w-full object-cover object-cover">
        <source :src="videoAssetRoot + props.data.video.filename_disk" :type="props.data.video.type">
      </video>
      <div class="gradient absolute -inset-1" />
    </div>

    <div class="relative whitespace-nowrap text-7.6rem font-title -mt-4rem">
      <span class="tabular-nums" /> {{ fancyDisplayNumber }}
      <span v-if="props.data.suffix">{{ props.data.suffix }}</span>
    </div>
    <p class="text-center text-balance text-1.6rem text-neutral-white">
      {{ props.data.description }}
    </p>
  </div>
</template>

<style scoped>
.gradient {
  background: linear-gradient(180deg, rgba(0, 11, 26, 0) 0%, #000711 100%);
}
</style>
